<h1 *ngIf="currentTicketType === 'BIG'" class="header">
  {{ 'bigTicket.header' | translate }}
</h1>
<app-card [title]="'companyAssociation.title' | translate">
  <div left-content>
    <form [formGroup]="companyAssociationForm">
      <div left-content class="content-container">
        <app-dropdown
          [label]="'companyAssociation.association'"
          [control]="companyAssociation"
          [options]="companyAssociationOptions"
          [optionsTranslationKey]="'companyAssociationOptions'"
          [error]="getCaErrors('companyAssociation')"
        ></app-dropdown>
        <div class="button-container">
          <app-deeplink-button
            [text]="'identification.buttonText' | translate"
            [loading]="loading"
            (buttonClicked)="handleButtonClick()"
          ></app-deeplink-button>
        </div>
        <div class="disclaimer-container">
          {{ "identification.disclaimer" | translate }}
        </div>
      </div>
    </form>
  </div>
  <div right-content>
    <app-contact></app-contact>
  </div>
</app-card>
